export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
]

export const withAuthAbility = (ability = []) => {
  const list = Array.isArray(ability) ? ability.filter(Boolean) : []
  if (!list.some(item => item && item.subject === 'Auth')) {
    list.unshift({ action: 'read', subject: 'Auth' })
  }
  return list
}

export const _ = undefined
